// #ux-redesign-start: Inbox view rediseñada — copia del patrón Doctors.
// Layout flush al navbar (sin Card>CardBody anidados):
//   inbox-page (PageContainer flush)
//     └─ inbox-body (flex row)
//         ├─ inbox-aside  (title + CTA Nuevo + sistema folders)
//         └─ inbox-main   (toolbar + list/detail/form)
//
// Mobile: cuando hay un mensaje seleccionado o el form está abierto,
// `inbox-page--detail-open` hace que el aside se oculte y el main ocupe todo
// el ancho. Sin componentes *Mobile separados.
//
// Backend: Patients NO tiene folders custom ni Papelera (las rutas están
// declaradas en MessagesPatientsController pero no en routes/patients.js), por
// eso el InboxMenu de Patients muestra solo system folders (Inbox / Sent /
// Important). El resto del look es idéntico a Doctors.
// ─────────────────────────────────────────────────────────────────────────────
import React, { useState, useEffect } from 'react';
import { useTranslate } from 'react-translate';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardBody } from 'reactstrap';

import { PageContainer } from 'components/ds';
import useResponsive from 'hooks/useResponsive';

import InboxMenu from 'components/Messages/InboxMenu';
import InboxBody from 'components/Messages/View/InboxBody';

import {
  actionSetMessage,
  actionGetMessages,
  actionOutboxGetMessages,
  actionGetPriorityMessages,
  actionSetBox,
} from 'store/actions/messagesActions';

const Inbox = () => {
  const t = useTranslate('messages');
  const dispatch = useDispatch();

  const [showForm, setShowForm] = useState(false);
  const [mobileViewMain, setMobileViewMain] = useState(false);

  const { message } = useSelector((state) => state.messagesReducer);
  const { isMobile } = useResponsive();

  const detailOpen = !!message || showForm || (isMobile && mobileViewMain);

  const handleFolderSelected = () => {
    if (isMobile) setMobileViewMain(true);
  };
  const handleBackToAside = () => setMobileViewMain(false);

  useEffect(() => {
    if (!window.location.href.includes('reply')) {
      dispatch(actionSetMessage());
      dispatch(actionSetBox('inbox'));
      dispatch(actionGetMessages());
      // counts del aside: outbox + priority requieren su propio fetch para
      // que el contador del item del menu refleje el total real.
      dispatch(actionOutboxGetMessages());
      dispatch(actionGetPriorityMessages());
    } else {
      setShowForm(true);
    }
  }, [dispatch]);

  const handleNewMessage = () => {
    dispatch(actionSetMessage());
    setShowForm(true);
  };

  return (
    <PageContainer
      className={`inbox-page${detailOpen ? ' inbox-page--detail-open' : ''}`}
    >
      <Card className="inbox-card-flush mb-0">
        <CardBody>
          <div className="inbox-body">
            <aside className="inbox-aside">
              <div className="inbox-aside-title">
                <span className="inbox-aside-title__icon" aria-hidden="true">
                  <i className="icon-inbox-header" />
                </span>
                <span className="inbox-aside-title__text">{t('title')}</span>
              </div>

              <div className="inbox-aside-header">
                <button
                  type="button"
                  className="inbox-new-btn"
                  onClick={handleNewMessage}
                >
                  <i className="icon-add" aria-hidden="true" />
                  <span>{t('btn-new') || t('new-message') || 'Neue Nachricht'}</span>
                </button>
              </div>

              <div className="inbox-aside-body">
                <InboxMenu
                  setShowForm={setShowForm}
                  onFolderSelected={handleFolderSelected}
                />
              </div>
            </aside>

            <section className="inbox-main">
              <InboxBody
                setShowForm={setShowForm}
                showForm={showForm}
                onBack={handleBackToAside}
              />
            </section>
          </div>
        </CardBody>
      </Card>
    </PageContainer>
  );
};

export default Inbox;
// #ux-redesign-end
